export default __webpack_public_path__ + "static/equilibre_icon_user-78ca503deadb821969943ad81f4d02e3.png";